import { Status } from 'modules/Global/status'

export const ALL_ORDER_STATUS: Status[] = [
  'CANCELED',
  'COMPLETED',
  'DISPATCHED',
  'ONGOING',
  'REFUNDED'
]
